<mat-card class="cardWithShadow">
    <mat-card-content>
        <mat-card-title>Recent Conversations</mat-card-title>

        <div class="timeline m-t-24">
            @for(stat of chats; track stat.id) {
            <div class="timeline-item d-flex overflow-hidden">
                <div class="time text-right mat-subtitle-1 f-s-14">{{ stat.lastModified | date: 'shortTime'}}</div>
                <div class="point d-flex align-items-center">
                    <span class="timeline-badge border-{{ colorFor(stat.id) }} m-y-8"></span>
                    <span class="timline-border d-block"></span>
                </div>
                <div class="desc">
                    @if(stat.messages[0].text) {
                    <span class="mat-subtitle-1 f-s-14 lh-20 f-w-600 d-block">{{
                            stat.messages[0].text
                        }}</span>
                    }

                    @if(stat.id) {
                        <a [routerLink]="['/conversations', stat.id]" class="text-primary text-decoration-none mat-body-1">Go to conversation</a>
                    }

                </div>
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>
